"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userScopes = void 0;
exports.userScopes = [
    'admin',
    'business',
    'editor',
    'moderator' // moderator of the system
];
